import React from "react";
import { TaskItemProps } from "../task-item";
import styles from "./project.module.css";
import { truncateText } from "../../../helpers/tuncated-text";

export const Project: React.FC<TaskItemProps> = ({ task, isSelected }) => {
  const barColor = isSelected
    ? task.styles.backgroundSelectedColor
    : task.styles.backgroundColor;

  const minBarWidth = 21;
  const projectWidth = Math.max(task.x2 - task.x1, minBarWidth);
  const left = task.x1;
  const right = left + projectWidth;

  const projectLeftTriangle = [
    left,
    task.y + task.height / 2 + 5,
    left,
    task.y + task.height,
    left + 15,
    task.y + task.height / 2 + 5,
  ].join(",");

  const projectRightTriangle = [
    right,
    task.y + task.height / 2 + 5,
    right,
    task.y + task.height,
    right - 15,
    task.y + task.height / 2 + 5,
  ].join(",");

  if (typeof task.showProgress !== "boolean") {
    task.showProgress = true;
  }

  return (
    <g
      tabIndex={0}
      className={styles.projectWrapper}
      id={task.id}
      data-taskId={task.id}
      data-type="Task"
    >
      {/* Filled portion of the progress bar */}
      <rect
        data-taskId={task.id}
        data-type="Task"
        x={task.progressX}
        width={Math.max(task.progressWidth, 0)}
        y={task.y}
        height={task.height / 2 + 5}
        rx={0}
        ry={task.barCornerRadius}
        className="rounded-t-sm"
        fill={barColor}
      />

      {/* Background of the bar */}
      <rect
        data-taskId={task.id}
        data-type="Task"
        fill={barColor + "a4"}
        x={left}
        width={projectWidth}
        y={task.y}
        height={task.height / 2 + 5}
        rx={0}
        ry={task.barCornerRadius}
        className={styles.projectTop + " rounded-t-md"}
      />

      {/* Task Name Text */}
      {projectWidth > 20 && (
        <text
          data-taskId={task.id}
          x={left + 5}
          y={task.y + task.height / 2 + 2}
          fontSize={Math.min(12, projectWidth / 4)}
          fill="#fff"
        >
          {truncateText(task.name, projectWidth)}
        </text>
      )}

      {/* Progress Percentage */}
      {projectWidth > 30 && task.showProgress && (
        <text
          data-taskId={task.id}
          x={
            Number(task.progress) === 100
              ? left + projectWidth - 35
              : left + projectWidth - 30
          }
          y={task.y + task.height / 2}
          fontSize={Math.min(12, projectWidth / 5)}
          fill="#fff"
        >
          {Number(task.progress).toFixed()}%
        </text>
      )}

      {/* Left Triangle - only if enough space */}
      {projectWidth > 30 && task.progressWidth > 15 && (
        <polygon
          data-taskId={task.id}
          className={styles.projectTop}
          points={projectLeftTriangle}
          fill={barColor}
        />
      )}
      {projectWidth > 20 && (
        <polygon
          data-taskId={task.id}
          className={styles.projectTop}
          points={projectLeftTriangle}
          fill={barColor + "a4"}
        />
      )}

      {/* Right Triangle - optional overlay */}
      {projectWidth > 20 && (
        <polygon
          className={styles.projectTop}
          points={projectRightTriangle}
          fill={barColor + "a4"}
        />
      )}
      {Math.round(task.progressWidth) === Math.round(projectWidth) &&
        projectWidth > 30 && (
          <polygon
            data-taskId={task.id}
            className={styles.projectTop}
            points={projectRightTriangle}
            fill={barColor}
          />
        )}
    </g>
  );
};
